<template>
  <elecBoardHeading></elecBoardHeading>
</template>
  
<script>
import elecBoardHeading from "@/components/elecBoard/elecBoardHeading";
export default {
  components: {
    elecBoardHeading,
  },
  setup() {},
};
</script>
  
<style lang="scss"></style>
  